import {getArchivedTooltipMessage} from 'analysis-tool/AnalysisToolMessages';
import isArchived from 'archive/isArchived';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {AnalysisTemplateGraphQL} from './templates/AnalysisTemplateTypes';

export type CanEditReturnValue = {canEdit: true; message: null} | {canEdit: false; message: string};

export function checkIsAnalysisArchived(
  analysis: Pick<PipelineGraphQL, 'id' | 'name'>,
  message?: string
): CanEditReturnValue | null {
  if (isArchived(analysis)) {
    return {
      canEdit: false,
      message: message ?? getArchivedTooltipMessage(analysis),
    };
  }
  return null;
}

/**
 * Check if a flowchart should show its edit functionality.
 *
 * @param analysis The analysis
 * @returns {shouldShow} False if the analysis is read-only.
 */
export function showFlowchartEditFunctionality(
  analysis: Pick<PipelineGraphQL, 'permissions'> | Pick<AnalysisTemplateGraphQL, 'permissions'>
): boolean {
  const {writable, archivable, unarchivable} = analysis.permissions;

  return writable || Boolean(archivable) || Boolean(unarchivable);
}
